// Resolves the ETL listing_group data behind a listings_scroller's
// `default_list_shown` value (a `listing_config.<uuid>` key).
//
// Extracted from ListingsScroller.getDefaultListing so the lookup can be unit
// tested. Every step used to be an unguarded property access, so a
// `default_list_shown` that names a listing_config the current flatData does
// not know about (stale value after a config swap, or a design copied to
// another account without its listing configurations — DEV-12182) crashed the
// whole renderer on SEARCH with "Cannot read properties of undefined
// (reading 'includes')". Returns `null` when the chain cannot be resolved so
// the caller can fall back to an empty default list instead of throwing.
export function resolveDefaultListing({ fd, etlData, configToCollectionMap, condorPropList, listingConfigUUID }) {
	if (!listingConfigUUID || typeof listingConfigUUID !== 'string') {
		return null;
	}

	// configToCollectionMap is a module-level object that ListingETLNew only
	// ever adds to, so a config swapped out of this design can keep a stale
	// entry. The config entity in flatData is the source of truth: without it
	// the map entry must not be trusted.
	if (!fd?.[listingConfigUUID]) {
		return null;
	}

	const collections = configToCollectionMap?.[listingConfigUUID];
	if (!Array.isArray(collections) || collections.length === 0) {
		return null;
	}

	let collectionName = '';
	(condorPropList || []).forEach((listingCollection) => {
		const componentData = fd?.[`component.${listingCollection?.component_name}`];
		if (!componentData) {
			return;
		}
		Object.keys(componentData).forEach((key1) => {
			if (key1.startsWith('listing_collection.') && collections.includes(key1)) {
				collectionName = key1;
			}
		});
	});

	const listingGroups = etlData?.[collectionName]?.listing_groups;
	if (!listingGroups) {
		return null;
	}

	let groupName = '';
	Object.keys(listingGroups).forEach((key1) => {
		if (key1.startsWith('listing_group.')) {
			groupName = key1;
		}
	});

	const group = listingGroups[groupName];
	if (!group || !Array.isArray(group.listings)) {
		return null;
	}

	return group;
}
